export const GET_NEXT_OF_KIN = "app/RESIDENT/GET_NEXT_OF_KIN";
export const GET_NEXT_OF_KIN_SUCCESS = "app/RESIDENT/GET_NEXT_OF_KIN_SUCCESS";
export const GET_NEXT_OF_KIN_FAILURE = "app/RESIDENT/GET_NEXT_OF_KIN_FAILURE";

export const SAVE_NEXT_OF_KIN = "app/RESIDENT/SAVE_NEXT_OF_KIN";
export const SAVE_NEXT_OF_KIN_SUCCESS = "app/RESIDENT/SAVE_NEXT_OF_KIN_SUCCESS";
export const SAVE_NEXT_OF_KIN_FAILURE = "app/RESIDENT/SAVE_NEXT_OF_KIN_FAILURE";

export const FETCH_OTHER_CONTACTS = "app/RESIDENT/FETCH_OTHER_CONTACTS";
export const FETCH_OTHER_CONTACTS_SUCCESS =
  "app/RESIDENT/FETCH_OTHER_CONTACTS_SUCCESS";
export const FETCH_OTHER_CONTACTS_FAILURE =
  "app/RESIDENT/FETCH_OTHER_CONTACTS_FAILURE";

export const ADD_OTHER_CONTACT = "app/RESIDENT/ADD_OTHER_CONTACT";
export const ADD_OTHER_CONTACT_SUCCESS =
  "app/RESIDENT/ADD_OTHER_CONTACT_SUCCESS";
export const ADD_OTHER_CONTACT_FAILURE =
  "app/RESIDENT/ADD_OTHER_CONTACT_FAILURE";

export const EDIT_OTHER_CONTACT = "app/RESIDENT/EDIT_OTHER_CONTACT";
export const EDIT_OTHER_CONTACT_SUCCESS =
  "app/RESIDENT/EDIT_OTHER_CONTACT_SUCCESS";
export const EDIT_OTHER_CONTACT_FAILURE =
  "app/RESIDENT/EDIT_OTHER_CONTACT_FAILURE";

export const DELETE_OTHER_CONTACT = "app/RESIDENT/DELETE_OTHER_CONTACT";
export const DELETE_OTHER_CONTACT_SUCCESS =
  "app/RESIDENT/DELETE_OTHER_CONTACT_SUCCESS";
export const DELETE_OTHER_CONTACT_FAILURE =
  "app/RESIDENT/DELETE_OTHER_CONTACT_FAILURE";

export const REMOVE_CONTACT = "app/RESIDENT/REMOVE_CONTACT";
export const REMOVE_CONTACT_SUCCESS = "app/RESIDENT/REMOVE_CONTACT_SUCCESS";
export const REMOVE_CONTACT_FAILURE = "app/RESIDENT/REMOVE_CONTACT_FAILURE";

export const TOGGLE_OTHER_KIN_MODAL = "app/RESIDENT/TOGGLE_OTHER_KIN_MODAL";

export const SEARCH_CONTACTS = "app/RESIDENT/SEARCH_CONTACTS";
export const SEARCH_CONTACTS_SUCCESS = "app/RESIDENT/SEARCH_CONTACTS_SUCCESS";
export const SEARCH_CONTACTS_FAILURE = "app/RESIDENT/SEARCH_CONTACTS_FAILURE";

export const GET_CONTACT_SUGGESTIONS = "app/RESIDENT/GET_CONTACT_SUGGESTIONS";
export const GET_CONTACT_SUGGESTIONS_SUCCESS =
  "app/RESIDENT/GET_CONTACT_SUGGESTIONS_SUCCESS";
export const GET_CONTACT_SUGGESTIONS_FAILURE =
  "app/RESIDENT/GET_CONTACT_SUGGESTIONS_FAILURE";

export const SEND_FAMILY_INVITE = "app/RESIDENT/SEND_FAMILY_INVITE";
export const SEND_FAMILY_INVITE_SUCCESS =
  "app/RESIDENT/SEND_FAMILY_INVITE_SUCCESS";
export const SEND_FAMILY_INVITE_FAILURE =
  "app/RESIDENT/SEND_FAMILY_INVITE_FAILURE";

export const RESEND_FAMILY_INVITE = "app/RESIDENT/RESEND_FAMILY_INVITE";
export const RESEND_FAMILY_INVITE_SUCCESS =
  "app/RESIDENT/RESEND_FAMILY_INVITE_SUCCESS";
export const RESEND_FAMILY_INVITE_FAILURE =
  "app/RESIDENT/RESEND_FAMILY_INVITE_FAILURE";

export const REVOKE_FAMILY_ACCESS = "app/RESIDENT/REVOKE_FAMILY_ACCESS";
export const REVOKE_FAMILY_ACCESS_SUCCESS =
  "app/RESIDENT/REVOKE_FAMILY_ACCESS_SUCCESS";
export const REVOKE_FAMILY_ACCESS_FAILURE =
  "app/RESIDENT/REVOKE_FAMILY_ACCESS_FAILURE";

export const TOGGLE_FAMILY_INVITE_MODAL =
  "app/RESIDENT/TOGGLE_FAMILY_INVITE_MODAL";

export const FETCH_FAMILY_ACCESS = "app/RESIDENT/FETCH_FAMILY_ACCESS";
export const FETCH_FAMILY_ACCESS_SUCCESS =
  "app/RESIDENT/FETCH_FAMILY_ACCESS_SUCCESS";
export const FETCH_FAMILY_ACCESS_FAILURE =
  "app/RESIDENT/FETCH_FAMILY_ACCESS_FAILURE";

export const FETCH_FAMILY_MODULE_PERMISSIONS =
  "app/RESIDENT/FETCH_FAMILY_MODULE_PERMISSIONS";
export const FETCH_FAMILY_MODULE_PERMISSIONS_SUCCESS =
  "app/RESIDENT/FETCH_FAMILY_MODULE_PERMISSIONS_SUCCESS";
export const FETCH_FAMILY_MODULE_PERMISSIONS_FAILURE =
  "app/RESIDENT/FETCH_FAMILY_MODULE_PERMISSIONS_FAILURE";
export const SAVE_FAMILY_MODULE_OVERRIDES =
  "app/RESIDENT/SAVE_FAMILY_MODULE_OVERRIDES";
export const SAVE_FAMILY_MODULE_OVERRIDES_SUCCESS =
  "app/RESIDENT/SAVE_FAMILY_MODULE_OVERRIDES_SUCCESS";
export const SAVE_FAMILY_MODULE_OVERRIDES_FAILURE =
  "app/RESIDENT/SAVE_FAMILY_MODULE_OVERRIDES_FAILURE";
